import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const inputCls = "w-full rounded-xl border border-[#212638] bg-[#0F111A] px-3 py-2.5 text-sm outline-none transition-colors focus:border-[#F7931A]";

export const ContactForm = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  const valid = subject.trim().length >= 3 && message.trim().length >= 10;

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/support/contact", { subject, message });
      setSent(data.ticket_id);
      setSubject("");
      setMessage("");
      toast.success("Message sent to our team");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  if (sent) return (
    <div className="flex h-[26rem] flex-col items-center justify-center text-center" data-testid="contact-success">
      <CheckCircle2 size={44} className="text-emerald-400" />
      <p className="mt-3 font-semibold">Message sent</p>
      <p className="mt-1 text-xs text-[#94A3B8]">We'll reply to your email. Ticket <span className="font-mono">{sent}</span></p>
      <button onClick={() => setSent(null)} data-testid="contact-send-another-button" className="mt-5 rounded-full border border-[#212638] px-4 py-2 text-xs text-[#94A3B8] transition-colors hover:bg-[#1C2030] hover:text-white">Send another</button>
    </div>
  );

  return (
    <div className="flex h-[26rem] flex-col gap-3">
      <p className="text-sm text-[#94A3B8]">Send a message to the team. We'll reply to the email on your account.</p>
      <input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject" maxLength={120} data-testid="contact-subject-input" className={inputCls} />
      <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="How can we help? (at least 10 characters)" maxLength={4000}
        data-testid="contact-message-input" className={`${inputCls} flex-1 resize-none`} />
      <button onClick={submit} disabled={!valid || busy} data-testid="contact-submit-button"
        className="flex items-center justify-center gap-2 rounded-xl bg-[#F7931A] py-2.5 text-sm font-semibold text-[#08090E] transition-colors hover:bg-amber-500 disabled:opacity-50">
        {busy && <Loader2 size={14} className="animate-spin" />} Send message
      </button>
    </div>
  );
};
